import { CreateProductDto, IProduct, ProductFilterDto, UpdateProductDto } from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class ProductApi {
  static getProducts(filter?: ProductFilterDto): Promise<AxiosResponse<IProduct[]>> {
    return AdmiralApi.apiCall<IProduct[]>({
      method: 'POST',
      url: `${BASE_URL}/product`,
      data: filter,
    });
  }

  static update(id: string, dto: UpdateProductDto): Promise<AxiosResponse<IProduct>> {
    return AdmiralApi.apiCall<IProduct>({
      method: 'PATCH',
      url: `${BASE_URL}/product/${id}`,
      data: dto,
    });
  }

  static create(dto: CreateProductDto): Promise<AxiosResponse<IProduct>> {
    return AdmiralApi.apiCall<IProduct>({
      method: 'PUT',
      url: `${BASE_URL}/product`,
      data: dto,
    });
  }

  static delete(id: string): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall<void>({
      url: `${BASE_URL}/product/${id}`,
      method: 'DELETE',
    });
  }
}
